import React from "react";
import ImageGallery from 'react-image-gallery';
import {Box} from "@mui/material";
import {size,useResizeHook} from '@/lib'
import ImagesGallery from '@/ui/images-gallery/images-gallery'
import {BUSINESS_NAME} from "@/content";
import {Image} from "@/types";

type ImageRendererProps = {
    images: Image[];
    showGallery?: boolean;
    showSlider?: boolean;
}

const ImagesRenderer = ({
                            images,
                            showGallery = false,
                            showSlider = false
                        }: ImageRendererProps) => {

    const {lessThanTablet} = useResizeHook();


    if (!images?.[0]?.url) return <></>

    return (
        <>
            {
                showGallery ? <>
                        <ImagesGallery images={images}/>
                    </>

                    : showSlider ? <>
                            <ImageGallery
                                items={images}
                                showThumbnails={true}
                                thumbnailPosition='bottom'
                                showBullets={true}
                                showNav={!lessThanTablet}
                                showPlayButton={false}
                                showFullscreenButton={!lessThanTablet}
                                disableSwipe={true}
                            />
                        </>

                        : <>

                            {images?.map((si) => (
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            mt: 1,
                                            mb: 2,
                                            minHeight: '350px', //for loader
                                            maxWidth: size.mobileL,
                                        }}
                                        key={si.id}>
                                        <img
                                            src={si.url}
                                            title={si.title || BUSINESS_NAME}
                                            alt={si.title || BUSINESS_NAME}
                                            height='auto'
                                            width='100%'
                                            // displayCaption
                                        />
                                    </Box>
                                )
                            )}

                        </>
            }
        </>)
}

export default ImagesRenderer


